module.exports = __webpack_public_path__ + "img/photoAlbum2.44690229.jpg";